<template>
  <div class="stationNewsMain">

    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('queryForm.dueDateNotification')" name="2">

        <!--        搜索-->
        <div class="searchList">
          <div class="searchInput">
            <div class="searchTitle">{{ $t('queryForm.keywords') }}</div>
            <input v-model="title" class="searchTxt" type="text">
          </div>
          <div class="searchBtn">
            <div class="btn-list-box form-btn-list">
              <cus-btn type="search" @click="search" />
            </div>
          </div>
        </div>

        <!--        列表-->
        <div
          v-for="(item, index) in listData"
          :key="'list1'+index"
          class="cardMain"
          @click="goMessageDetails(item)"
        >
          <i v-if="item.isRead == 0" />
          <div class="cardTitle">
            <div class="cardTitle_ttile overflow" style="max-width: 80%;">{{ item.title }}</div>
            <div class="cardTitle_time">{{ item.createTime }}</div>
          </div>
          <div class="cardTxt overflow">{{ item.content }}</div>
        </div>

        <pagination-page :total="total" :change-fun="pageChange" />
      </el-tab-pane>

      <el-tab-pane :label="$t('queryForm.systemNotification')" name="1">

        <!--        搜索-->
        <div class="searchList">
          <div class="searchInput">
            <div class="searchTitle">{{ $t('queryForm.keywords') }}</div>
            <input v-model="title" class="searchTxt" type="text">
          </div>
          <div class="searchBtn">
            <div class="btn-list-box form-btn-list">
              <cus-btn type="search" @click="search" />
            </div>
          </div>
        </div>

        <!--        列表-->
        <div
          v-for="(item, index) in listData"
          :key="'list1'+index"
          class="cardMain"
          @click="goMessageDetails(item)"
        >
          <i v-if="item.isRead == 0" />
          <div class="cardTitle">
            <div class="cardTitle_ttile overflow" style="max-width: 80%;">{{ item.title }}</div>
            <div class="cardTitle_time">{{ item.createTime }}</div>
          </div>
          <div class="cardTxt overflow">{{ item.content }}</div>
        </div>

        <pagination-page :total="total" :change-fun="pageChange" />
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>

import { sysNoticeSelect } from '../../api/adminManagement'

export default {
  data() {
    return {
      activeName: '2',

      queryTitle: '',
      title: '',

      listData: [],

      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  watch: {
    activeName() {
      this.pageNum = 1
      this.pageSize = 10
      this.title = ''
      this.queryTitle = ''
      this.setSysNoticeSelect()
    }
  },
  mounted() {
    this.activeName = this.$route.query.activeName || '2'
    this.setSysNoticeSelect()
  },
  methods: {

    /**
    * 搜索
    */
    search() {
      this.pageNum = 1
      this.pageSize = 10
      this.queryTitle = this.title
      this.setSysNoticeSelect()
    },

    /**
    * 分页选择
    */
    pageChange(pageNum, pageSize) {
      this.pageNum = pageNum
      this.pageSize = pageSize
      this.setSysNoticeSelect()
    },

    /**
    * 获取消息列表
    */
    setSysNoticeSelect() {
      const self = this
      sysNoticeSelect({
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        type: self.activeName,
        keywords: self.queryTitle
        // title: self.queryTitle
      }).then(response => {
        if (response.code === 200) {
          self.listData = []
          self.total = response.data.total
          if (response.data.list && response.data.list.length) {
            self.listData = response.data.list
          }
        }
      })
    },

    /**
    * 跳转到消息详情页面
    */
    goMessageDetails(dataInfo) {
      this.$router.push({
        name: 'stationNewsDetails',
        query: {
          messageId: dataInfo.id,
          activeName: this.activeName,
          backToPage: 'stationNewsIndex'
        }
      })
    }
  }
}
</script>

<style lang="scss">
    .stationNewsMain {
        padding: 0 20px;
        .el-tabs__header{
          margin-left: 20px;
        }

        .el-tabs__nav-wrap::after {
            background-color: transparent !important;
        }

        .el-tabs__active-bar {
            width: 50px !important;
            height: 4px !important;
        }

        .el-tabs__item {
            font-size: 18px;
            color: #999999;
        }

        .el-tabs__item.is-active {
            color: #409EFF;
        }

        .searchList {
            margin-bottom: 30px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            margin-left:20px ;

            .searchTitle {
                line-height: 40px;
                font-size: 16px;
            }

            .searchTxt {
                font-size: 14px;
                display: inline-block;
                width: 600px;
                -webkit-appearance: none;
                background-color: #FFF;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #DCDFE6;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #606266;
                display: inline-block;
                font-size: inherit;
                height: 40px;
                line-height: 40px;
                outline: 0;
                padding: 0 15px;
                -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
                transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
            }

            .searchBtn {
                margin-left: 60px;
            }
        }

        .cardMain {
            padding: 25px 35px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 11px 0px rgba(38, 64, 99, 0.13);
            border-radius: 10px;
            // margin-bottom: 20px;
            margin: 0 20px 20px 20px;

            position: relative;

            &:hover {
                background: rgba(239, 239, 239, 1);
                cursor: pointer;
            }

            i {
                width: 12px;
                height: 12px;
                background: #FE0000;
                display: inline-block;
                position: absolute;
                left: 12px;
                top: 12px;
                border-radius: 50%;
            }

            .cardTitle {
                display: flex;
                justify-content: space-between;
                font-size: 18px;
                margin-bottom: 18px;

                .cardTitle_ttile {
                    font-weight: bold;
                }

                .cardTitle_time {
                    font-size: 14px;
                    color: #999999;
                }
            }

            .cardTxt {
                font-size: 14px;
                color: #666666;
            }
        }

    }

</style>
